export type Region = "au" | "nz" | "us" | "generic";

export interface RegionTerms {
  label: string;
  flag: string;
  adjustmentType: string;
  adjustmentTypePlural: string;
  adjustmentShort: string;
  complianceSystem: string;
  behaviourSpelling: string;
  termUnit: string;
  termUnits: string;
  yearLevelPrefix: string;
  uploadedToSystem: string;
  uploadFilterLabel: string;
  exportAdjustmentColHeader: string;
  csvRecordTypeLabel: string;
  programmeSpelling: string;
}

export const REGION_CONFIG: Record<Region, RegionTerms> = {
  au: {
    label: "Australia",
    flag: "🇦🇺",
    adjustmentType: "NCCD Adjustment",
    adjustmentTypePlural: "NCCD Adjustments",
    adjustmentShort: "NCCD",
    complianceSystem: "NCCD",
    behaviourSpelling: "Behaviour",
    termUnit: "Term",
    termUnits: "Terms",
    yearLevelPrefix: "Year",
    uploadedToSystem: "Uploaded to Sentral / school system",
    uploadFilterLabel: "Sentral / system status",
    exportAdjustmentColHeader: "NCCD Adjustments",
    csvRecordTypeLabel: "NCCD Adjustment",
    programmeSpelling: "Programme",
  },
  nz: {
    label: "New Zealand",
    flag: "🇳🇿",
    adjustmentType: "ORS Record",
    adjustmentTypePlural: "ORS Records",
    adjustmentShort: "ORS",
    complianceSystem: "ORS / Learning Support",
    behaviourSpelling: "Behaviour",
    termUnit: "Term",
    termUnits: "Terms",
    yearLevelPrefix: "Year",
    uploadedToSystem: "Uploaded to school system",
    uploadFilterLabel: "Upload status",
    exportAdjustmentColHeader: "ORS / Support Adjustments",
    csvRecordTypeLabel: "ORS/Support Record",
    programmeSpelling: "Programme",
  },
  us: {
    label: "United States",
    flag: "🇺🇸",
    adjustmentType: "IEP / 504 Record",
    adjustmentTypePlural: "IEP / 504 Records",
    adjustmentShort: "IEP/504",
    complianceSystem: "IEP / 504",
    behaviourSpelling: "Behavior",
    termUnit: "Semester",
    termUnits: "Semesters",
    yearLevelPrefix: "Grade",
    uploadedToSystem: "Uploaded to school system",
    uploadFilterLabel: "Upload status",
    exportAdjustmentColHeader: "IEP / 504 Accommodations",
    csvRecordTypeLabel: "IEP/504 Record",
    programmeSpelling: "Program",
  },
  generic: {
    label: "International / Other",
    flag: "🌐",
    adjustmentType: "Adjustment Record",
    adjustmentTypePlural: "Adjustment Records",
    adjustmentShort: "Adjustment",
    complianceSystem: "Compliance Documentation",
    behaviourSpelling: "Behaviour",
    termUnit: "Term",
    termUnits: "Terms",
    yearLevelPrefix: "Year",
    uploadedToSystem: "Uploaded to school system",
    uploadFilterLabel: "Upload status",
    exportAdjustmentColHeader: "Adjustments Made",
    csvRecordTypeLabel: "Adjustment Record",
    programmeSpelling: "Programme",
  },
};

export function getRegionTerms(region: string | null | undefined): RegionTerms {
  return REGION_CONFIG[(region as Region) ?? "au"] ?? REGION_CONFIG.au;
}

export const ALL_REGIONS: Region[] = ["au", "nz", "us", "generic"];
